import { render } from "./KostenRegulaer.vue?vue&type=template&id=6ef7bdc9"
import script from "./KostenRegulaer.vue?vue&type=script&lang=js"
export * from "./KostenRegulaer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__